// extracted by mini-css-extract-plugin
module.exports = {"section":"Logos_section__lYeTA","item":"Logos_item__sW7pp","imageWrapper":"Logos_imageWrapper__GXQwG","image":"Logos_image__BWMK3"};